module.exports = __webpack_public_path__ + "img/delete-failed.a2c72856.svg";